var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileExcel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.206,
    height: 21.608,
    viewBox: "0 0 16.206 21.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-excel",
    "data-name": "Icon awesome-file-excel",
    d: "M9.454,5.74V0H1.013A1.01,1.01,0,0,0,0,1.013V20.6a1.01,1.01,0,0,0,1.013,1.013h14.18A1.01,1.01,0,0,0,16.206,20.6V6.753h-5.74A1.016,1.016,0,0,1,9.454,5.74Zm2.536,4.495L9.454,14.18l2.536,3.946a.507.507,0,0,1-.426.781H10.091a.508.508,0,0,1-.447-.266c-.827-1.528-1.54-2.9-1.54-2.9-.27.625-.422.844-1.545,2.9a.5.5,0,0,1-.443.266H4.642a.507.507,0,0,1-.426-.781l2.545-3.946L4.216,10.239a.506.506,0,0,1,.426-.781H6.111a.508.508,0,0,1,.447.266c1.1,2.06.844,1.418,1.545,2.891,0,0,.257-.494,1.545-2.891a.508.508,0,0,1,.447-.266h1.469A.5.5,0,0,1,11.99,10.234Zm4.216-5.09V5.4H10.8V0h.257a1.012,1.012,0,0,1,.717.3l4.132,4.136A1.01,1.01,0,0,1,16.206,5.145Z",
    fill: "#1f7244"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileExcel);
export default __webpack_public_path__ + "static/media/file-excel.0585e2c01688e23d4fe86d520bb21d63.svg";
export { ForwardRef as ReactComponent };